import { useEffect, useState } from "react";
import { recordInviteClick, recordPageView } from "./analytics";

const API_URL = `${process.env.REACT_APP_API_URL || ""}/api/v1/simon-configs`;

function isSafeHttpUrl(value) {
  try {
    const url = new URL(String(value || "").trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

function InviteLink({ href, className, style, onClick, children }) {
  if (!href) {
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
      onClick={onClick}
    >
      {children}
    </a>
  );
}

function App() {
  const [inviteLink, setInviteLink] = useState("");

  useEffect(() => {
    fetch(API_URL, {
      headers: { "ngrok-skip-browser-warning": "true" },
    })
      .then((res) => res.json())
      .then((body) => {
        const link = body?.data?.SGQuitSmokingInviteLink;
        setInviteLink(isSafeHttpUrl(link) ? link.trim() : "");
      })
      .catch(() => {
        setInviteLink("");
      });
  }, []);

  useEffect(() => {
    recordPageView();
  }, []);

  return (
    <InviteLink
      href={inviteLink}
      onClick={recordInviteClick}
      className="grid min-h-screen w-full grid-cols-1 bg-cover bg-center bg-no-repeat no-underline md:grid-cols-[40%_60%]"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/background.png)`,
      }}
    >
      <div className="flex items-center justify-center p-6 md:p-10">
        <img
          src={`${process.env.PUBLIC_URL}/no-smoking.png`}
          alt="No smoke"
          className="h-auto max-h-[80vh] w-full max-w-xl object-contain"
        />
      </div>

      <section className="flex flex-col items-center justify-center px-8 py-16 text-center md:px-16">
        <h1 className="luxury-title">JOIN US TO EXPLORE MORE</h1>
        <p className="luxury-subtitle mt-6">
          Break Free Today, Say Goodbye to Smoking
        </p>
        <span className="luxury-button mt-10">Explore More</span>
      </section>
    </InviteLink>
  );
}

export default App;
